import { formatCardKey } from '@/ai/utils/helpers'
import { buildPrompt } from '@/ai/utils/promptBuilder'
import { systemMessages } from '@/ai/prompts/common/systemMessages'
import { getJsonOutputFormatting } from '@/ai/prompts/common/formatting'
import {
  diagramToJson,
  createUserMessage,
  createSystemMessage,
  getWorkflowBackgroundSections
} from '@/ai/utils/promptUtils'

export const buildSingleCardPrompt = ({
  eventId,
  workflow,
  svgGraph,
  svgLanes,
  cardTypes,
  cardTypeId
}) => {
  const messages = []

  messages.push(createSystemMessage(systemMessages.EVENT_MODELING_DDD_EXPERT))

  const promptSections = []

  const { workflow: currentDiagram, currentStep } = workflow.eventsJson?.length
    ? diagramToJson(eventId, workflow, svgGraph, svgLanes)
    : { workflow: [], currentStep: undefined }
  const workflowBackgroundSections = getWorkflowBackgroundSections(workflow, currentDiagram, cardTypes)
  const cardType = cardTypes.find((cardType) => cardType.id === cardTypeId)
  const cardTypeTitle = cardType.title
  const currentStepObject = currentDiagram[currentStep - 1]

  promptSections.push(...workflowBackgroundSections)

  promptSections.push({
    title: 'Request',
    content: [
      `Suggest one more ${cardTypeTitle} (${cardType.description}) to be added
       to step ${currentStep} (${currentStepObject.role}: ${currentStepObject.description}).`,
      `The ${cardTypeTitle} must be relevant to the workflow as a whole and must not already exist in the workflow.`
    ]
  })

  const cardExample = { [formatCardKey(cardTypeTitle)]: 'Example text' }

  promptSections.push({
    title: 'Formatting',
    flattenLines: false,
    content: getJsonOutputFormatting(formatCardKey(cardTypeTitle), JSON.stringify(cardExample))
  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
